// biome-ignore-all lint/security/noDangerouslySetInnerHtml: pre-sanitised

import type { Attachment } from '@cucumber/messages'
import Convert from 'ansi-to-html'
import type { FC } from 'react'

import { CopyButton } from '../../app/CopyButton.js'
import type { AttachmentClasses } from '../../customise/index.js'
import { useText } from './useText.js'

export const Log: FC<{
  attachment: Attachment
  classes: AttachmentClasses
}> = ({ attachment, classes }) => {
  const { content } = useText(attachment)
  return (
    <div className={`${classes.text} ${classes.log}`}>
      <pre>
        <span dangerouslySetInnerHTML={{ __html: prettyANSI(content) }} />
      </pre>
      <CopyButton className={classes.copyButton} text={content} />
    </div>
  )
}

function prettyANSI(s: string) {
  return new Convert().toHtml(s)
}
